// extracted by mini-css-extract-plugin
module.exports = {"IamModal":"iam_IamModal__CMJCv","err":"iam_err__qjCHS","spinner":"iam_spinner__X0o1i"};